// extracted by mini-css-extract-plugin
export var label = "_jt-0";
export var treatmentCard = "_jt-1";